/*

AFTER applying the Product Filter & Search to this theme, 
replace the code in bc-sf-filter.js with this code
(or use a comparison tool to copy over relevant changes and test)

*/

// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    numberFilterTree: 2,
    showLimitList: "24,36,48",
  },
};

// Declare Templates
var bcSfFilterTemplate = {
  // Grid Template
  productGridItemHtml:
    '<article class="{{customClass}}" data-product-item tabindex="1">' +
    '<div id="{{itemHandle}}" class="productitem" data-product-item-content>' +
    '<a class="productitem--image-link" href="{{itemUrl}}">' +
    '<figure class="productitem--image" data-product-item-image>' +
    '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">' +
    "{{rebateSticker}}" +
    "</figure>" +
    "</a>" +
    '<div class="productitem--info">' +
    '<div class="productitem--info-title-container">' +
    "{{emphasizePrice}}" +
    '<h2 class="productitem--title">' +
    '<a href="{{itemUrl}}" tabindex="1">' +
    '<span class="product-grid-brand">{{brand}}</span>{{itemTitle}}' +
    "</a>" +
    "</h2>" +
    "{{noEmphasizePrice}}" +
    "{{itemVendor}}" +
    "{{itemReviews}}" +
    '<a href="{{itemUrl}}" tabindex="1" style="text-decoration: none;">{{lowestpricesticker}}</a>' +
    '<a href="#" data-fancybox data-src="#delivery-saver-popup" tabindex="1" style="text-decoration: none;">{{deliverySaverSticker}}</a>' +
    '</div><div class="productitem--info-stickers-container">' +
    "{{stickers}}" +
    "{{sampleButton}}" +
    "</div>" +
    "</div>" +
    // modified by Q 3/6/19
    '<div class="productitem--icon-multiple-prices tooltip" style="display:none;">' +
    "<a href='{{itemUrl}}'>" +
    '<svg width="65" height="53" viewBox="0 0 130 106" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<rect x="27" y="3" width="100" height="100" fill="white" stroke="#85888D" stroke-width="5"/>' +
    '<rect x="15" y="23" width="80" height="80" fill="white" stroke="#85888D" stroke-width="5"/>' +
    '<rect x="3" y="41" width="62" height="62" fill="white" stroke="#85888D" stroke-width="5"/>' +
    "</svg>" +
    "</a>" +
    '<div class="right">' +
    '<div class="heading-wrapper"><span class="heading">{{multiple_prices_available_heading}}</span></div>' +
    '<span class="text">{{multiple_prices_available_text}}</span>' +
    "<i></i>" +
    "</div>" +
    "</div>" +
    // end modification

    "{{quickBtn}}" +
    "</div>" +
    "</article>",

  productListItemHtml:
    '<article class="{{customClass}}" data-product-item >' +
    '<div id="{{itemHandle}}" class="productitem">' +
    '<a class="productitem--image-link" href="{{itemUrl}}">' +
    '<figure class="productitem--image" data-product-item-image>' +
    '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">' +
    "{{itemLabels}}" +
    "</figure>" +
    "</a>" +
    '<div class="productitem--info">' +
    "{{emphasizePrice}}" +
    '<h2 class="productitem--title">' +
    '<a href="{{itemUrl}}" tabindex="1">' +
    "{{itemTitle}}" +
    "</a>" +
    "</h2>" +
    "{{noEmphasizePrice}}" +
    "{{itemVendor}}" +
    "{{itemReviews}}" +
    "{{itemDescription}}" +
    "</div>" +
    "{{quickBtn}}" +
    "</div>" +
    "</article>",

  // Pagination Template
  previousActiveHtml:
    '<li class="pagination--previous"><a class="pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' +
    bcSfFilterConfig.label.prev +
    "</a></li>",
  previousDisabledHtml: "",
  nextActiveHtml:
    '<li class="pagination--next"><a class="pagination--item" href="{{itemUrl}}">' +
    bcSfFilterConfig.label.next +
    '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
  nextDisabledHtml: "",
  pageItemHtml:
    '<li><a class="pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml:
    '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
  pageItemRemainHtml:
    '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
  paginateHtml:
    '<div class="pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

  // Sorting Template
  sortingHtml:
    '<label class="utils-sortby-title" for="product_grid_sort">' +
    bcSfFilterConfig.label.sorting +
    "</label>" +
    '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
    '<select class="form-field form-field-select">{{sortingItems}}</select>' +
    '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg>' +
    "</div>",

  // Show limit Template
  showLimitHtml:
    '<li><span class="utils-showby-title">' +
    bcSfFilterConfig.label.show_per_page +
    "</span></li>{{showLimitItems}}",
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (
  data,
  index,
  totalProduct,
) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // initMin price for map price
  var variant_min_price = data.price_max;
  var meta_price = false;

  //init stickers var
  var s_sample = false;
  var s_local = false;
  var s_shipping = false;
  var s_lowestPriceSticker = false;
  var s_image_sticker = false;
  var s_content_sticker = false;
  var s_deliverySaverSticker = false;

  for (var i = 0; i < data.variants.length; i++) {
    //console.log(data.variants[i]);
    var sample = getVariantMetafield(data, data.variants[i], "sample");
    //console.log(bcsffilter.getProductMetafield(data, data.variants[i].id, 'map_price'));
    console.log("sampleType:", sample);

    var brand_name = getVariantMetafield(data, data.variants[i], "brand");

    if (
      sample == "4x4" ||
      sample == "free" ||
      sample == "full" ||
      sample == "sample" ||
      sample == "full_only" ||
      sample == "4x4SelectSample" ||
      sample == "4x4PremiumSample" ||
      sample == "FullPremium"
    ) {
      var sample_el =
        '<button data-fancybox  data-brand="' +
        brand_name +
        '" data-src="#collection-open-modal" data-handle="' +
        data.handle +
        '" type="button"  class="collection-sample-button">Get Sample</button><span class="collection-sample-success">Sample Added to Cart</span>';
      itemHtml = itemHtml.replace(/{{sampleButton}}/g, sample_el);
    } else if (
      (sample == "" ||
        sample === undefined ||
        sample === null ||
        sample === "null" ||
        sample == "FALSE") &&
      i + 1 == data.variants.length
    ) {
      itemHtml = itemHtml.replace(/{{sampleButton}}/g, "");
    } else {
      itemHtml = itemHtml.replace(/{{sampleButton}}/g, "");
    }

    //map price
    console.log(
      "variant_min_price test: ",
      variant_min_price,
      data.variants[i].price,
    );
    if (variant_min_price >= data.variants[i].price) {
      var map_price = getVariantMetafield(data, data.variants[i], "map_price");

      if (map_price && map_price !== "null" && map_price != "FALSE") {
        meta_price = map_price;
        variant_min_price = data.variants[i].price;
      } else {
        if (meta_price != "add to cart" && map_price != "FALSE") {
          meta_price = 0;
        }
      }
    }

    var FreeSampleSticker = getVariantMetafield(
      data,
      data.variants[i],
      "free_sample_sticker",
    );

    //check if there are stickers
    if (
      s_sample == false &&
      FreeSampleSticker !== null &&
      FreeSampleSticker !== "null" &&
      FreeSampleSticker != "FALSE"
    ) {
      s_sample = true;
    }

    var FreeLocalSticker = getVariantMetafield(
      data,
      data.variants[i],
      "free_local_sticker",
    );

    if (
      s_local == false &&
      FreeLocalSticker !== null &&
      FreeLocalSticker !== "null" &&
      FreeLocalSticker != "FALSE"
    ) {
      var localShippingValue = FreeLocalSticker;
      s_local = true;
    }

    var FreeShippingSticker = getVariantMetafield(
      data,
      data.variants[i],
      "free_shipping_sticker",
    );

    if (
      s_shipping == false &&
      FreeShippingSticker !== null &&
      FreeShippingSticker !== "null" &&
      FreeShippingSticker != "FALSE"
    ) {
      var freeShippingValue = FreeShippingSticker;
      s_shipping = true;
    }

    var LowestPriceSticker = getVariantMetafield(
      data,
      data.variants[i],
      "lowest_price_sticker",
    );

    if (
      s_lowestPriceSticker == false &&
      LowestPriceSticker !== null &&
      LowestPriceSticker !== "null" &&
      LowestPriceSticker != "FALSE"
    ) {
      s_lowestPriceSticker = true;
    }

    var DeliverySaverSticker = getVariantMetafield(
      data,
      data.variants[i],
      "delivery_saver_sticker",
    );

    if (
      s_deliverySaverSticker == false &&
      DeliverySaverSticker !== null &&
      DeliverySaverSticker !== "null" &&
      DeliverySaverSticker != "FALSE"
    ) {
      s_deliverySaverSticker = true;
    }

    var ImageSticker = getVariantMetafield(
      data,
      data.variants[i],
      "image_sticker_content",
    );

    console.log("IMAGE STICKER", ImageSticker);

    if (
      s_image_sticker == false &&
      ImageSticker !== "null" &&
      ImageSticker !== null &&
      ImageSticker !== "FALSE"
    ) {
      s_image_sticker = ImageSticker;
    }

    var ContentSticker = getVariantMetafield(
      data,
      data.variants[i],
      "lowest_price_sticker_content",
    );

    if (
      s_content_sticker == false &&
      ContentSticker != "null" &&
      ContentSticker !== "FALSE"
    ) {
      s_content_sticker = ContentSticker;
    }

    //console.log('variant_min_price: ', variant_min_price);
    //console.log('metaprice:  ', meta_price);
  }

  //add brand

  if (brand_name == "dal" || brand_name == "Daltile") {
    brand_name = "Daltile&nbsp;";
  } else if (brand_name == "MSI") {
    brand_name = "MSI&nbsp;";
  } else if (brand_name == "eleganza" || brand_name == "Eleganza") {
    brand_name = "Eleganza&nbsp;";
  } else if (brand_name == "Marazzi") {
    brand_name = "Marazzi&nbsp;";
  } else if (brand_name == "American Olean") {
    brand_name = "American Olean&nbsp;";
  } else if (brand_name == "Bedrosians") {
    brand_name = "Bedrosians&nbsp;";
  } else if (brand_name == "Iris") {
    brand_name = "Iris&nbsp;";
  } else if (brand_name == "Milestone") {
    brand_name = "Milestone&nbsp;";
  } else if (brand_name == "Happy Floors") {
    brand_name = "Happy Floors&nbsp;";
  } else if (brand_name == "Mohawk") {
    brand_name = "Mohawk&nbsp;";
  } else if (brand_name == "Interceramic") {
    brand_name = "Interceramic&nbsp;";
  } else if (brand_name == "Emser") {
    brand_name = "Emser&nbsp;";
  } else if (brand_name == "Ottimo") {
    brand_name = "Ottimo&nbsp;";
  } else if (brand_name == "Gaia") {
    brand_name = "Gaia&nbsp;";
  } else if (brand_name == "Schluter Systems") {
    brand_name = "Schluter Systems&nbsp;";
  } else if (brand_name == "Mir") {
    brand_name = "MIR&nbsp;";
  } else if (brand_name == "Elysium") {
    brand_name = "Elysium&nbsp;";
  } else if (brand_name == "Euroker") {
    brand_name = "Euroker&nbsp;";
  } else if (brand_name == "Kertiles") {
    brand_name = "Kertiles&nbsp;";
  } else if (brand_name == "Tesoro") {
    brand_name = "Tesoro&nbsp;";
  } else if (brand_name == "Provenza") {
    brand_name = "Provenza&nbsp;";
  } else if (brand_name == "California Classics") {
    brand_name = "California Classics&nbsp;";
  } else if (brand_name == "Florenza Ceramic") {
    brand_name = "Florenza Ceramic&nbsp;";
  } else if (brand_name == "Bosphorus Imports") {
    brand_name = "Bosphorus Imports&nbsp;";
  } else if (brand_name == "Somer Tile") {
    brand_name = "Somer Tile&nbsp;";
  } else if (brand_name == "Style Access") {
    brand_name = "Style Access&nbsp;";
  } else if (brand_name == "Voguebay") {
    brand_name = "Voguebay&nbsp;";
  } else if (brand_name == "Shaw") {
    brand_name = "Shaw&nbsp;";
  } else if (brand_name == "Floorigami") {
    brand_name = "Floorigami&nbsp;";
  } else if (brand_name == "Philadelphia Commercial") {
    brand_name = "Philadelphia Commercial&nbsp;";
  } else if (brand_name == "Arizona Tile") {
    brand_name = "Arizona Tile&nbsp;";
  } else if (brand_name == "Flexco") {
    brand_name = "Flexco&nbsp;";
  } else if (brand_name == "California Tile Supply") {
    brand_name = "California Tile Supply&nbsp;";
  } else if (brand_name == "Republic") {
    brand_name = "Republic&nbsp;";
  } else if (brand_name == "Cancos Tile & Stone") {
    brand_name = "Cancos Tile & Stone&nbsp;";
  } else if (brand_name == "Pergo") {
    brand_name = "Pergo&nbsp;";
  } else if (brand_name == "Mannington") {
    brand_name = "Mannington&nbsp;";
  } else if (brand_name == "Phenix") {
    brand_name = "Phenix&nbsp;";
  } else if (brand_name == "Anderson Tuftex") {
    brand_name = "Anderson Tuftex&nbsp;";
  } else if (brand_name == "HF Design") {
    brand_name = "HF Design&nbsp;";
  } else if (brand_name == "D&M") {
    brand_name = "D&M&nbsp;";
  } else if (brand_name == "EkoWood") {
    brand_name = "EkoWood&nbsp;";
  } else if (brand_name == "PanTim") {
    brand_name = "PanTim&nbsp;";
  } else if (brand_name == "Next Floor") {
    brand_name = "Next Floor&nbsp;";
  } else if (brand_name == "Raskin") {
    brand_name = "Raskin&nbsp;";
  } else if (brand_name == "Cintek") {
    brand_name = "Cintek&nbsp;";
  } else if (brand_name == "Elite") {
    brand_name = "Elite&nbsp;";
  } else if (brand_name == "MP Global") {
    brand_name = "MP Global&nbsp;";
  } else if (brand_name == "Bostik") {
    brand_name = "Bostik&nbsp;";
  } else if (brand_name == "DriTac") {
    brand_name = "DriTac&nbsp;";
  } else if (brand_name == "Tarkett") {
    brand_name = "Tarkett&nbsp;";
  } else if (brand_name == "Pliteq") {
    brand_name = "Pliteq&nbsp;";
  } else if (brand_name == "WE Cork") {
    brand_name = "WE Cork&nbsp;";
  } else if (brand_name == "Ua Floors") {
    brand_name = "Ua Floors&nbsp;";
  } else if (brand_name == "Wellmade") {
    brand_name = "Wellmade&nbsp;";
  } else if (brand_name == "Toucan") {
    brand_name = "Toucan&nbsp;";
  } else if (brand_name == "American Flooring") {
    brand_name = "American Flooring&nbsp;";
  } else if (brand_name == "Roca") {
    brand_name = "Roca&nbsp;";
  } else if (brand_name == "Forbo") {
    brand_name = "Forbo&nbsp;";
  } else if (brand_name == "COREtec") {
    brand_name = "COREtec&nbsp;";
  } else if (brand_name == "Aladdin Commercial") {
    brand_name = "Aladdin Commercial&nbsp;";
  } else if (brand_name == "Happy Feet") {
    brand_name = "Happy Feet&nbsp;";
  } else if (brand_name == "Nourison") {
    brand_name = "Nourison&nbsp;";
  } else if (brand_name == "Homesourced") {
    brand_name = "Homesourced&nbsp;";
  } else if (brand_name == "BHW Floors") {
    brand_name = "BHW Floors&nbsp;";
  } else if (brand_name == "Armstrong") {
    brand_name = "Armstrong&nbsp;";
  } else if (brand_name == "Smart Turf") {
    brand_name = "Smart Turf&nbsp;";
  } else if (brand_name == "Paradigm") {
    brand_name = "Paradigm&nbsp;";
  } else if (brand_name == "Metroflor") {
    brand_name = "Metroflor&nbsp;";
  } else if (brand_name == "AtWork") {
    brand_name = "AtWork&nbsp;";
  } else if (brand_name == "Resolve") {
    brand_name = "Resolve&nbsp;";
  } else if (brand_name == "Stanton") {
    brand_name = "Stanton&nbsp;";
  } else if (brand_name == "Antrim by Stanton") {
    brand_name = "Antrim by Stanton&nbsp;";
  } else if (brand_name == "Stanton DWF") {
    brand_name = "Stanton DWF&nbsp;";
  } else if (brand_name == "Stanton Street Commercial") {
    brand_name = "Stanton Street Commercial&nbsp;";
  } else if (brand_name == "Revolution Mills") {
    brand_name = "Revolution Mills&nbsp;";
  } else if (brand_name == "Maniscalco") {
    brand_name = "Maniscalco&nbsp;";
  } else if (brand_name == "Europine") {
    brand_name = "Europine&nbsp;";
  } else if (brand_name == "Karndean Designflooring") {
    brand_name = "Karndean Designflooring&nbsp;";
  } else if (brand_name == "Marquis") {
    brand_name = "Marquis&nbsp;";
  } else if (brand_name == "Johnson Hardwood") {
    brand_name = "Johnson Hardwood&nbsp;";
  } else if (brand_name == "Rosecore by Stanton") {
    brand_name = "Rosecore by Stanton&nbsp;";
  } else if (brand_name == "Hibernia by Stanton") {
    brand_name = "Hibernia by Stanton&nbsp;";
  } else if (brand_name == "Crescent by Stanton") {
    brand_name = "Crescent by Stanton&nbsp;";
  } else if (brand_name == "Cavan by Stanton") {
    brand_name = "Cavan by Stanton&nbsp;";
  } else if (brand_name == "Jeffrey Court") {
    brand_name = "Jeffrey Court&nbsp;";
  } else if (brand_name == "Island Stone") {
    brand_name = "Island Stone&nbsp;";
  } else if (brand_name == "Versatrim") {
    brand_name = "Versatrim&nbsp;";
  } else if (brand_name == "Floors 2000 by Stanton") {
    brand_name = "Floors 2000 by Stanton&nbsp;";
  } else if (brand_name == "Ragno USA") {
    brand_name = "Ragno USA&nbsp;";
  } else if (brand_name == "Successions") {
    brand_name = "Successions&nbsp;";
  } else if (brand_name == "AHF") {
    brand_name = "AHF&nbsp;";
  } else if (brand_name == "Specialty Tile Products") {
    brand_name = "Specialty Tile Products&nbsp;";
  } else if (brand_name == "Zia Tile") {
    brand_name = "Zia Tile&nbsp;";
  } else if (brand_name == "Roppe") {
    brand_name = "Roppe&nbsp;";
  } else if (brand_name == "Mission Collection") {
    brand_name = "Mission Collection&nbsp;";
  } else if (brand_name == "Kahrs") {
    brand_name = "Kahrs&nbsp;";
  } else if (brand_name == "Inhaus") {
    brand_name = "Inhaus&nbsp;";
  } else if (brand_name == "Audacity") {
    brand_name = "Audacity&nbsp;";
  } else if (brand_name == "Excelsior") {
    brand_name = "Excelsior&nbsp;";
  } else if (brand_name == "AHF Contract") {
    brand_name = "AHF Contract&nbsp;";
  } else if (brand_name == "Craft + Main") {
    brand_name = "Craft + Main&nbsp;";
  } else if (brand_name == "Karran") {
    brand_name = "Karran&nbsp;";
  } else if (brand_name == "CeramicaEtc") {
    brand_name = "CeramicaEtc&nbsp;";
  } else if (brand_name == "Shawgrass") {
    brand_name = "Shawgass&nbsp;";
  } else if (brand_name == "NG Kutahya") {
    brand_name = "NG Kutahya&nbsp;";
  } else if (brand_name == "Palacio") {
    brand_name = "Palacio&nbsp;";
  } else if (brand_name == "Pan American Ceramics") {
    brand_name = "Pan American Ceramics&nbsp;";
  } else if (brand_name == "Stainless Steel Tile") {
    brand_name = "Stainless Steel Tile&nbsp;";
  } else if (brand_name == "Gemcore") {
    brand_name = "Gemcore&nbsp;";
  } else if (brand_name == "Monarch Plank") {
    brand_name = "Monarch Plank&nbsp;";
  } else if (brand_name == "Reward Flooring") {
    brand_name = "Reward Flooring&nbsp;";
  } else if (brand_name == "Moma Ceramiche") {
    brand_name = "Moma Ceramiche&nbsp;";
  } else if (brand_name == "Keystone Tile") {
    brand_name = "Keystone Tile&nbsp;";
  } else if (brand_name == "Parliament Floors") {
    brand_name = "Parliament Floors&nbsp;";
  } else if (brand_name == "Stanza International") {
    brand_name = "Stanza International&nbsp;";
  } else if (brand_name == "Hartco") {
    brand_name = "Hartco&nbsp;";
  } else if (brand_name == "Grand Pacific") {
    brand_name = "Grand Pacific&nbsp;";
  } else if (brand_name == "Northwest Floors and Home") {
    brand_name = "Northwest Floors and Home&nbsp;";
  } else if (brand_name == "Iflush") {
    brand_name = "Iflush&nbsp;";
  } else if (brand_name == "Amerock") {
    brand_name = "Amerock&nbsp;";
  } else if (brand_name == "Muller Graff") {
    brand_name = "Muller Graff&nbsp;";
  } else if (brand_name == "Hallmark Floors") {
    brand_name = "Hallmark Floors&nbsp;";
  } else if (brand_name == "Dowell") {
    brand_name = "Dowell&nbsp;";
  } else if (brand_name == "Bravada Hardwood") {
    brand_name = "Bravada Hardwood&nbsp;";
  } else if (brand_name == "QuickStep") {
    brand_name = "QuickStep&nbsp;";
  } else if (brand_name == "Floormuffler") {
    brand_name = "Floormuffler&nbsp;";
  } else if (brand_name == "Berenson") {
    brand_name = "Berenson&nbsp;";
  } else if (brand_name == "Big D Supply") {
    brand_name = "Big D Supply&nbsp;";
  } else if (brand_name == "StonePeak Ceramics") {
    brand_name = "StonePeaks Ceramics&nbsp;";
  } else if (brand_name == "Traxx") {
    brand_name = "Traxx&nbsp;";
  } else if (brand_name == "Elite Tiles") {
    brand_name = "Elite Tiles&nbsp;";
  } else if (brand_name == "Premium Kitchen") {
    brand_name = "Premium Kitchen&nbsp;";
  } else if (brand_name == "Pliteq") {
    brand_name = "Pliteq&nbsp;";
  } else if (brand_name == "Ardex") {
    brand_name = "Ardex&nbsp;";
  } else if (brand_name == "Bellezza Ceramica") {
    brand_name = "Bellezza Ceramica&nbsp;";
  } else if (brand_name == "Vanity Art") {
    brand_name = "Vanity Art&nbsp;";
  } else if (brand_name == "Quick-Step") {
    brand_name = "Quick-Step&nbsp;";
  } else if (brand_name == "Granada Cabinets") {
    brand_name = "Granada Cabinets&nbsp;";
  } else if (brand_name == "Cabinets R Us") {
    brand_name = "Cabinets R Us&nbsp;";
  } else if (brand_name == "Autograph") {
    brand_name = "Autograph&nbsp;";
  } else if (brand_name == "Lexora") {
    brand_name = "Lexora&nbsp;";
  } else if (brand_name == "Amerfit Hardware") {
    brand_name = "Amerfit Hardware&nbsp;";
  } else if (brand_name == "Sterfic") {
    brand_name = "Sterfic&nbsp;";
  } else if (brand_name == "Elkay") {
    brand_name = "Elkay&nbsp;";
  } else if (brand_name == "PKB Cabinetry") {
    brand_name = "PKB Cabinetry&nbsp;";
  } else if (brand_name == "LX Building Materials") {
    brand_name = "LX Building Materials&nbsp;";
  } else if (brand_name == "Persn") {
    brand_name = "Persn&nbsp;";
  } else if (brand_name == "Verum Italy") {
    brand_name = "Verum Italy&nbsp;";
  } else if (brand_name == "Blue Valley Cabinets") {
    brand_name = "Blue Valley Cabinets&nbsp;";
  } else if (brand_name == "Heatgene") {
    brand_name = "Heatgene&nbsp;";
  } else if (brand_name == "Unielegance") {
    brand_name = "Unielegance&nbsp;";
  } else if (brand_name == "Knobhill") {
    brand_name = "Knobhill&nbsp;";
  } else if (brand_name == "Chandra") {
    brand_name = "Chandra&nbsp;";
  } else if (brand_name == "Vision Cabinet") {
    brand_name = "Vision Cabinet&nbsp;";
  } else if (brand_name == "John Boos") {
    brand_name = "John Boos&nbsp;";
  } else if (brand_name == "Duko") {
    brand_name = "Duko&nbsp;";
  } else if (brand_name == "Chandra") {
    brand_name = "Chandra&nbsp;";
  } else if (brand_name == "Raphael Stone") {
    brand_name = "Raphael Stone&nbsp;";
  } else if (brand_name == "Woodbridge") {
    brand_name = "Woodbridge&nbsp;";
  }else if (brand_name == "Southwind") {
    brand_name = "Southwind&nbsp;";
  }else if (brand_name == "Laurey") {
    brand_name = "Laurey&nbsp;";
  }else if (brand_name == "MNG") {
    brand_name = "MNG&nbsp;";
  }else if (brand_name == "Paradise") {
    brand_name = "Paradise&nbsp;";
  }else if (brand_name == "LX Hausys") {
    brand_name = "LX Hausys&nbsp;";
  }else if (brand_name == "Padua Surfaces") {
    brand_name = "Padua Surfaces&nbsp;";
  }else if (brand_name == "Skyline Cabinetry") {
    brand_name = "Skyline Cabinetry&nbsp;";
  }else {
    brand_name = "";
  }

  itemHtml = itemHtml.replace(/{{brand}}/g, brand_name);

  //lowest price sticker
  if (s_lowestPriceSticker) {
    var lowerPriceSticker_content = "Add to cart for Instant Rebate";
    if (s_content_sticker) {
      lowerPriceSticker_content = s_content_sticker;
    }
    var lowestPriceStickerTemplate = `<div class="lowest-price-ribbon-container lowest-price-sticker">
    <div class="lowest-price-ribbon-image">
      <img src="https://cdn.shopify.com/s/files/1/1394/1063/files/lowest_price-circle.jpg?v=1628867017">
    </div>
    <div class="lowest-price-ribbon-flex-container">
      <div class="lowest-price-ribbon">
        <div class="lowest-price-ribbon-content">
			${lowerPriceSticker_content}
        </div>
      </div>
    </div>
  </div>`;
    itemHtml = itemHtml.replace(
      /{{lowestpricesticker}}/g,
      lowestPriceStickerTemplate,
    );
  } else {
    itemHtml = itemHtml.replace(/{{lowestpricesticker}}/g, "");
  }

  //delivery saver sticker
  if (s_deliverySaverSticker) {
    var stickerContent = "SAVER Delivery options available!";
    var deliverySaverTemplate = `<div class="lowest-price-ribbon-container lowest-price-sticker">
    <div class="lowest-price-ribbon-image">
      <img src="https://cdn.shopify.com/s/files/1/1394/1063/files/delivery-saver-circle-icon.png?v=1658563830">
    </div>
    <div class="lowest-price-ribbon-flex-container">
      <div class="lowest-price-ribbon">
        <div class="lowest-price-ribbon-content">
			${stickerContent}
        </div>
      </div>
    </div>
  </div>`;
    itemHtml = itemHtml.replace(
      /{{deliverySaverSticker}}/g,
      deliverySaverTemplate,
    );
  } else {
    itemHtml = itemHtml.replace(/{{deliverySaverSticker}}/g, "");
  }

  //check if has min map price
  var map_price = false;
  console.log("meta_price: ", meta_price);
  var product_minimum_price = data.price_min;
  if (meta_price != 0 && meta_price != false) {
    map_price = true;
    product_minimum_price = meta_price;
    //set min price to meta price if min price is less than meta price

    /*
      if(data.price_min_usd > meta_price){
        product_minimum_price = meta_price;
      }*/
  }

  //replace sticker template
  if (s_local || s_shipping || s_sample) {
    var sticker_template = '<div class="custom_logocart"><ul>';
    if (s_sample)
      sticker_template +=
        '<li class="free-sample-logo custom-sticker"><span class="sticker-icon"><img src="//cdn.shopify.com/s/files/1/1394/1063/files/sec.png?15559"></span><span> free samples </span></li>';
    if (s_local)
      sticker_template +=
        '<li data-fancybox data-src="#local-sticker-popup" class="free-local-pickup custom-sticker"><span class="sticker-icon"><img src="//cdn.shopify.com/s/files/1/1394/1063/files/cart_f502a98c-3b03-4957-9b4e-63413e529e6b.png?15559"></span><span>' +
        localShippingValue +
        "</span></li>";
    if (s_shipping) {
      sticker_template +=
        '<li class="free-shipping-logo custom-sticker"><span class="sticker-icon"><img src="//cdn.shopify.com/s/files/1/1394/1063/files/van_66fb0891-b4a0-4910-9870-6958bc5de0e3.png?15559"></span><span>' +
        freeShippingValue +
        "</span></li>";
    }
    sticker_template += "</ul></div>";
    itemHtml = itemHtml.replace(/{{stickers}}/g, sticker_template);
  } else {
    itemHtml = itemHtml.replace(/{{stickers}}/g, "");
  }

  // Add custom class
  var customClass =
    "productgrid--item imagestyle--" +
    bcSfFilterConfig.custom.product_grid_image_style;
  if (onSale) customClass += " productitem--sale";
  if (bcSfFilterConfig.custom.emphasize_price)
    customClass += " productitem--emphasis";
  itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

  // Add Thumbnail
  var itemThumbUrl =
    images.length > 0
      ? this.optimizeImage(images[0]["src"], "512x")
      : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Label
  var itemLabelsHtml = "";
  if (soldOut) {
    itemLabelsHtml +=
      '<span class="productitem--badge badge--soldout">' +
      bcSfFilterConfig.label.sold_out +
      "</span>";
  } else {
    if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
      var savePrice = data.compare_at_price_min - data.price_min;
      var percentSavePrice = Math.round(
        (savePrice * 100) / data.compare_at_price_max,
      );
      var savePriceHtml =
        '<span class="money" data-price-money-saved>' +
        this.formatMoney(savePrice) +
        "</span>";
      var percentSavePriceHtml =
        "<span data-price-percent-saved>" + percentSavePrice + "</span>";
      itemLabelsHtml +=
        '<span class="productitem--badge badge--sale" data-badge-sales>';
      switch (bcSfFilterConfig.custom.product_sales_badge_style) {
        case "percentile":
          itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(
            /{{ saved }}/g,
            percentSavePriceHtml,
          );
          break;
        case "money":
          itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(
            /{{ saved }}/g,
            this.formatMoney(savePrice),
          );
          break;
        default:
          itemLabelsHtml += bcSfFilterConfig.label.sale;
          break;
      }
      itemLabelsHtml += "</span>";
    }
  }
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  // modified by Q 3/6/19
  // Add multiple Prices icon
  var multHeading = document.getElementById(
    "multiple_prices_available_heading",
  ).textContent;
  var multText = document.getElementById(
    "multiple_prices_available_text",
  ).textContent;
  if (priceVaries) {
    itemHtml = itemHtml.replace("display:none;", "display:block;");
    itemHtml = itemHtml.replace(
      /{{multiple_prices_available_heading}}/g,
      multHeading,
    );
    itemHtml = itemHtml.replace(
      /{{multiple_prices_available_text}}/g,
      multText,
    );
  }

  // Add Price
  var priceHtml = "";
  var classVaries = priceVaries ? "price--varies" : "";
  var classMapPrice = "";
  var strikePriceClass = "";
  var visibleClass =
    onSale || bcSfFilterConfig.custom.emphasize_price ? "visible" : "";
  priceHtml +=
    '<div class="productitem--price ' +
    classVaries +
    " " +
    classMapPrice +
    '">';
  priceHtml += '<div class="price--main ' + strikePriceClass + '" data-price>';

  var unit = "";

  if (data.tags) {
    var tag = data.tags.find(function (e) {
      return e.indexOf("unit") > -1;
    });
    if (typeof tag != "undefined") {
      unit = tag.split("_").slice(-1)[0];
    }
  }

  if (
    (meta_price != 0 && meta_price != false) ||
    (s_image_sticker !== false && s_image_sticker !== null)
  ) {
    var image_rebate_text = "Instant Rebate in Cart";
    if (s_image_sticker != false && s_image_sticker != null) {
      image_rebate_text = s_image_sticker;
    }

    var rebateStickerHtml = `<div class="product-rebate-badge">
                                  <div class="product-rebate-badge-ribbon">
                                    <div class="product-rebate-badge-ribbon-content">
										${image_rebate_text}
                                    </div>
                                  </div>
                                </div>`;

    itemHtml = itemHtml.replace(/{{rebateSticker}}/g, rebateStickerHtml);
  } else {
    itemHtml = itemHtml.replace(/{{rebateSticker}}/g, "");
  }

  //remove price if disable add to cart is found
  if (data.tags.includes("DISABLE_ADD_TO_CART")) {
    itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, "");
    itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, "");
  }

  if (meta_price == "add to cart") {
    priceHtml = `<div class="productitem--price  "><a href="${data.url}" style="text-decoration: none;"><div class="price--main " data-price=""><span>See Price in Cart</span></div></a></div>`;
    itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, priceHtml);
  }

  var priceHtmlByUnit =
    "<span>" +
    this.formatMoney(product_minimum_price) +
    " / " +
    unit +
    "</span>";

  if (priceVaries) {
    priceHtml += bcSfFilterConfig.label.range_html.replace(
      /{{ price }}/g,
      priceHtmlByUnit,
    );
  } else {
    if (onSale) {
      priceHtml += '<span class="visually-hidden">Current Price</span>';
    }
    priceHtml += priceHtmlByUnit;
  }
  priceHtml += "</div>";

  //priceHTML closing tag
  priceHtml += "</div>";
  // Add emphasize price
  var emphasizePriceHtml = "";
  var noEmphasizePriceHtml = "";
  if (bcSfFilterConfig.custom.emphasize_price) {
    emphasizePriceHtml += priceHtml;
  } else {
    noEmphasizePriceHtml += priceHtml;
  }

  itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
  itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

  // Add vendor
  var itemVendorHtml = "";
  if (bcSfFilterConfig.custom.show_vendor && data.vendor !== "") {
    itemVendorHtml +=
      '<h3 class="productitem--vendor">' + data.vendor + "</h3>";
  }
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add review rating
  var itemReviewsHtml = "";
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    itemReviewsHtml +=
      '<div class="productitem--ratings">' +
      '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
      '<span class="spr-badge">' +
      '<span class="spr-starrating spr-badge-starrating">' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      "</span>" +
      "</span>" +
      "</span>" +
      "</div>";
  }
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

  // Add quickBtn
  var quickBtnHtml = "";
  var has_variants =
    firstVariant["option_title"] == "Default Title" ? false : true;
  var show_modal = bcSfFilterConfig.custom.show_modal;
  if (
    bcSfFilterConfig.custom.enable_quick_look == true ||
    bcSfFilterConfig.custom.enable_quick_buy == true
  ) {
    var quick_look_text = bcSfFilterConfig.label.quick_look_text;
    var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
    var quick_look_classes = "productitem--action-trigger button-secondary";
    var quick_buy_classes =
      "productitem--action-trigger productitem--action-atc button-primary";
    if (has_variants) {
      quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
      show_modal = true;
    }
    if (!data.available) {
      quick_buy_text = bcSfFilterConfig.label.sold_out;
      quick_buy_classes = quick_buy_classes + " disabled";
    }
    quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
    if (bcSfFilterConfig.custom.enable_quick_look) {
      quickBtnHtml +=
        '<div class="productitem--action">' +
        '<button class="' +
        quick_look_classes +
        '" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' +
        quick_look_text +
        "</button>" +
        "</div>";
    }
    if (bcSfFilterConfig.custom.enable_quick_buy) {
      if (!has_variants) {
        var temp = " data-quick-buy ";
      } else {
        var temp = " data-quickshop-slim ";
      }
      quickBtnHtml +=
        '<div class="productitem--action">' +
        '<button class="' +
        quick_buy_classes +
        '" tabindex="1" type="button" aria-label="' +
        quick_buy_text +
        '"' +
        temp +
        'data-variant-id="' +
        data.variants[0].id +
        '"';
      if (!data.available) {
        quickBtnHtml += " disabled";
      }
      quickBtnHtml += ">";
      quickBtnHtml +=
        '<span class="atc-button--text">' + quick_buy_text + "</span>";
      quickBtnHtml += '<span class="atc-button--icon">';
      quickBtnHtml +=
        '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';
      quickBtnHtml += "</span>";
      quickBtnHtml += "</button>";
      quickBtnHtml += "</div>";
    }

    quickBtnHtml += "</div>";
  }
  itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  // Build content for Modal
  var quickUrl = this.buildProductItemUrl(data) + "?view=quickview";
  jQ.ajax({
    url: quickUrl,
    success: function (result) {
      jQ("#" + data.handle).after(result);
      jQ("#" + data.handle)
        .find(".productitem--action")
        .css("display", "block");

      if (index == totalProduct) {
        var sections = new bcSections();
        sections.register("static-collection", function (section) {
          return new bcStaticCollection(section);
        });
      }
    },
  });

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (
  data,
  index,
  totalProduct,
) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Add custom class
  var customClass =
    "productgrid--item imagestyle--" +
    bcSfFilterConfig.custom.product_grid_image_style;
  if (onSale) customClass += " productitem--sale";
  if (bcSfFilterConfig.custom.emphasize_price)
    customClass += " productitem--emphasis";
  itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

  // Add Thumbnail
  var itemThumbUrl =
    images.length > 0
      ? this.optimizeImage(images[0]["src"], "512x")
      : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Label
  var itemLabelsHtml = "";
  if (soldOut) {
    itemLabelsHtml +=
      '<span class="productitem--badge badge--soldout">' +
      bcSfFilterConfig.label.sold_out +
      "</span>";
  } else {
    if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
      var savePrice = data.compare_at_price_min - data.price_min;
      var percentSavePrice = Math.round(
        (savePrice * 100) / data.compare_at_price_max,
      );
      var savePriceHtml =
        '<span class="money" data-price-money-saved>' +
        this.formatMoney(savePrice) +
        "</span>";
      var percentSavePriceHtml =
        "<span data-price-percent-saved>" + percentSavePrice + "</span>";
      itemLabelsHtml +=
        '<span class="productitem--badge badge--sale" data-badge-sales>';
      switch (bcSfFilterConfig.custom.product_sales_badge_style) {
        case "percentile":
          itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(
            /{{ saved }}/g,
            percentSavePriceHtml,
          );
          break;
        case "money":
          itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(
            /{{ saved }}/g,
            this.formatMoney(savePrice),
          );
          break;
        default:
          itemLabelsHtml += bcSfFilterConfig.label.sale;
          break;
      }
      itemLabelsHtml += "</span>";
    }
  }
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  // Add Price
  var priceHtml = "";
  var classVaries = priceVaries ? "price--varies" : "";
  var visibleClass =
    onSale || bcSfFilterConfig.custom.emphasize_price ? "visible" : "";
  priceHtml += '<div class="productitem--price ' + classVaries + '">';
  priceHtml +=
    '<div class="price--compare-at ' +
    visibleClass +
    '" data-price-compare-at>';
  var comparePrice =
    '<span class="money">' +
    this.formatMoney(data.compare_at_price_min) +
    "</span>";
  if (priceVaries && onSale) {
    priceHtml += bcSfFilterConfig.label.range_html.replace(
      /{{ price }}/g,
      comparePrice,
    );
  } else {
    if (onSale) {
      priceHtml += comparePrice;
    } else {
      if (bcSfFilterConfig.custom.emphasize_price) {
        priceHtml += '<span class="price--spacer"></span>';
      } else {
        priceHtml += '<span class="money"></span>';
      }
    }
  }
  priceHtml += "</div>";
  priceHtml += '<div class="price--main" data-price>';
  var price =
    '<span class="money">' + this.formatMoney(data.price_min) + "</span>";
  if (priceVaries) {
    priceHtml += bcSfFilterConfig.label.range_html.replace(
      /{{ price }}/g,
      price,
    );
  } else {
    priceHtml += price;
  }
  priceHtml += "</div>";
  priceHtml += "</div>";

  // Add quickBtn
  var quickBtnHtml = "";
  var has_variants =
    firstVariant["option_title"] == "Default Title" ? false : true;
  var show_modal = bcSfFilterConfig.custom.show_modal;
  if (
    bcSfFilterConfig.custom.enable_quick_look == true ||
    bcSfFilterConfig.custom.enable_quick_buy == true
  ) {
    var quick_look_text = bcSfFilterConfig.label.quick_look_text;
    var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
    var quick_look_classes = "productitem--action-trigger button-secondary";
    var quick_buy_classes =
      "productitem--action-trigger productitem--action-atc button-primary";
    if (has_variants) {
      quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
      show_modal = true;
    }
    if (!data.available) {
      quick_buy_text = bcSfFilterConfig.label.sold_out;
      quick_buy_classes = quick_buy_classes + " disabled";
    }
    quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
    quickBtnHtml +=
      '<div class="productitem--listview-price">' +
      "{{emphasizePrice}}" +
      "</div>" +
      '<div class="productitem--listview-badge"></div>';
    if (bcSfFilterConfig.custom.enable_quick_look) {
      quickBtnHtml +=
        '<div class="productitem--action">' +
        '<button class="' +
        quick_look_classes +
        '" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' +
        quick_look_text +
        "</button>" +
        "</div>";
    }
    if (bcSfFilterConfig.custom.enable_quick_buy) {
      if (!has_variants) {
        var temp = " data-quick-buy ";
      } else {
        var temp = " data-quickshop-slim ";
      }
      quickBtnHtml +=
        '<div class="productitem--action">' +
        '<button class="' +
        quick_buy_classes +
        '" tabindex="1" type="button" aria-label="' +
        quick_buy_text +
        '"' +
        temp +
        'data-variant-id="' +
        data.variants[0].id +
        '"';
      if (!data.available) {
        quickBtnHtml += " disabled";
      }
      quickBtnHtml += ">";
      quickBtnHtml +=
        '<span class="atc-button--text">' + quick_buy_text + "</span>";
      quickBtnHtml += '<span class="atc-button--icon">';
      quickBtnHtml +=
        '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path> </g> </svg>';
      quickBtnHtml += "</span>";
      quickBtnHtml += "</button>";
      quickBtnHtml += "</div>";
    }

    quickBtnHtml += "</div>";
  }
  itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);

  // Add emphasize price
  var emphasizePriceHtml = "";
  var noEmphasizePriceHtml = "";
  if (bcSfFilterConfig.custom.emphasize_price) {
    emphasizePriceHtml += priceHtml;
  } else {
    noEmphasizePriceHtml += priceHtml;
  }
  itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
  itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

  // Add vendor
  var itemVendorHtml = "";
  if (bcSfFilterConfig.custom.show_vendor && data.vendor !== "") {
    itemVendorHtml +=
      '<h3 class="productitem--vendor">' + data.vendor + "</h3>";
  }
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add review rating
  var itemReviewsHtml = "";
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    itemReviewsHtml +=
      '<div class="productitem--ratings">' +
      '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
      '<span class="spr-badge">' +
      '<span class="spr-starrating spr-badge-starrating">' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      "</span>" +
      "</span>" +
      "</span>" +
      "</div>";
  }
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

  // Add description
  var itemDescriptionHtml = "";
  if (data.description && data.description.length > 0) {
    itemDescriptionHtml +=
      '<div class="productitem--description">' +
      "<p>" +
      bcsffilter.truncateByChar(data.description, 150) +
      "</p>" +
      "</div>";
    if (data.description.length > 150) {
      itemDescriptionHtml +=
        '<a href="{{itemUrl}}" class="productitem--link">' +
        bcSfFilterConfig.label.view_details +
        "</a>";
    }
  }
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  // Build content for Modal
  var quickUrl = this.buildProductItemUrl(data) + "?view=quickview";
  jQ.ajax({
    url: quickUrl,
    success: function (result) {
      jQ("#" + data.handle).after(result);
      jQ("#" + data.handle)
        .find(".productitem--action")
        .css("display", "block");

      if (index == totalProduct) {
        var sections = new bcSections();
        sections.register("static-collection", function (section) {
          return new bcStaticCollection(section);
        });
      }
    },
  });

  return itemHtml;
};

function getVariantMetafield(data, variant, key) {
  var metafield = data.metafields.find(
    (mf) =>
      mf.key === key && (mf.namespace == variant.id || mf.id === variant.id),
  );
  if (metafield) return metafield.value;

  return null;
}

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html("");
    return false;
  }

  if (this.getSettingValue("general.paginationType") == "default") {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;

    // Build Previous
    var previousHtml =
      currentPage > 1
        ? bcSfFilterTemplate.previousActiveHtml
        : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink("page", currentPage, currentPage - 1),
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? bcSfFilterTemplate.nextActiveHtml
        : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink("page", currentPage, currentPage + 1),
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);

    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }

    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? bcSfFilterTemplate.pageItemSelectedHtml
            : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, pageArr[iPage]),
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    jQ(this.selector.pagination).html(paginationHtml);
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
    jQ(this.selector.topSorting).html("");

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml,
      );
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + " select").val(this.queryParams.sort);
    }
  }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
  if (bcSfFilterTemplate.hasOwnProperty("showLimitHtml")) {
    jQ(this.selector.topShowLimit).html("");

    var numberList = this.getSettingValue("general.showLimitList");
    if (numberList != "") {
      // Build content
      var showLimitItemsHtml = "";
      var arr = numberList.split(",");
      for (var k = 0; k < arr.length; k++) {
        if (arr[k] == this.queryParams.limit) {
          showLimitItemsHtml +=
            '<li><a class="utils-showby-item active" href="' +
            arr[k] +
            '">' +
            arr[k] +
            "</a></li>";
        } else {
          showLimitItemsHtml +=
            '<li><a class="utils-showby-item" href="' +
            arr[k] +
            '">' +
            arr[k] +
            "</a></li>";
        }
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(
        /{{showLimitItems}}/g,
        showLimitItemsHtml,
      );
      jQ(this.selector.topShowLimit).html(html);
    }
  }
};

BCSfFilter.prototype.buildShowLimitEvent = function () {
  var _this = this;
  jQ(this.selector.topShowLimit + " li a").click(function (e) {
    onInteractWithToolbar(
      e,
      "limit",
      _this.queryParams.limit,
      jQ(this).attr("href"),
    );
  });
};

/************************** END BUILD TOOLBAR **************************/

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
  if (typeof colData !== "undefined" && colData.hasOwnProperty("collection")) {
    var colInfo = colData.collection;
    var delimiter =
      '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
    var breadcrumbHtml =
      '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + "</a> ";
    breadcrumbHtml += delimiter;
    breadcrumbHtml += " <span>" + colInfo.title + "</span>";
    jQ(".breadcrumbs-container").html(breadcrumbHtml);
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml =
    '<span class="utils-viewtoggle-label">' +
    bcSfFilterConfig.label.view_as_title +
    " </span>";
  itemHtml +=
    '<button class="active bc-sf-filter-display-grid" data-display-type="' +
    this.buildToolbarLink("display", "list", "grid") +
    '">';
  itemHtml +=
    '<svg class="icon-grid " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h4v4H5V5zm6 0h4v4h-4V5zm-6 6h4v4H5v-4zm6 0h4v4h-4v-4z"></path>    </svg>';
  itemHtml == "</button>";
  itemHtml +=
    '<button class="bc-sf-filter-display-list" data-display-type= "' +
    this.buildToolbarLink("display", "grid", "list") +
    '">';
  itemHtml +=
    '<svg class="icon-list " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h10v2H5V5zm0 4h10v2H5V9zm0 4h10v2H5v-2z"></path>    </svg>';
  itemHtml == "</button>";

  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType).find("button").removeClass("active");
  if (this.queryParams.display == "list") {
    jQ(this.selector.topDisplayType)
      .find("button.bc-sf-filter-display-list")
      .addClass("active");
  } else if (this.queryParams.display == "grid") {
    jQ(this.selector.topDisplayType)
      .find("button.bc-sf-filter-display-grid")
      .addClass("active");
  }
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
  var _this = this;
  jQ(this.selector.topDisplayType + " button").unbind("click");
  jQ(this.selector.topDisplayType + " button").click(function (e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children("button").removeClass("active");
    jQ(this).addClass("active");
    var newUrl = jQ(this).attr("data-display-type");
    if (newUrl.indexOf("list") != -1) {
      jQ(".productgrid--outer").addClass("productgrid-listview");
    } else {
      jQ(".productgrid--outer").removeClass("productgrid-listview");
    }
    _this.onChangeData(newUrl, "display");
  });
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  // var sections = new Sections();
  // sections.register('static-collection', function (section) {
  //     return new StaticCollection(section);
  // });

  // Integrate Product Reviews
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    !(function () {
      var e = function (e) {
        var t = { exports: {} };
        return (e.call(t.exports, t, t.exports), t.exports);
      };
      e(function () {
        "use strict";
        window.innerShiv = (function () {
          function e(e, t, r) {
            return /^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(
              r,
            )
              ? e
              : t + "></" + r + ">";
          }
          var t,
            r,
            a = document,
            i =
              "abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(
                " ",
              );
          return function (n, s) {
            if (
              !t &&
              ((t = a.createElement("div")),
              (t.innerHTML = "<nav></nav>"),
              (r = 1 !== t.childNodes.length))
            ) {
              for (var o = a.createDocumentFragment(), d = i.length; d--; )
                o.createElement(i[d]);
              o.appendChild(t);
            }
            if (
              ((n = n
                .replace(/^\s\s*/, "")
                .replace(/\s\s*$/, "")
                .replace(
                  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
                  "",
                )
                .replace(/(<([\w:]+)[^>]*?)\/>/g, e)),
              (t.innerHTML = (o = n.match(
                /^<(tbody|tr|td|col|colgroup|thead|tfoot)/i,
              ))
                ? "<table>" + n + "</table>"
                : n),
              (o = o ? t.getElementsByTagName(o[1])[0].parentNode : t),
              !1 === s)
            )
              return o.childNodes;
            for (
              var d = a.createDocumentFragment(), u = o.childNodes.length;
              u--;
            )
              d.appendChild(o.firstChild);
            return d;
          };
        })();
      });
      (function () {
        ((window.SPR = (function () {
          function e() {}
          return (
            (e.shop = Shopify.shop),
            (e.host = "//productreviews.shopifycdn.com"),
            (e.version = "v4"),
            (e.api_url = e.host + "/proxy/" + e.version),
            (e.badgeEls = []),
            (e.reviewEls = []),
            (e.elSettings = {}),
            (e.$ = void 0),
            (e.extraAjaxParams = { shop: e.shop }),
            (e.registerCallbacks = function () {
              return (
                this.$(document).bind(
                  "spr:badge:loaded",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onBadgeLoad
                    : void 0,
                ),
                this.$(document).bind(
                  "spr:product:loaded",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onProductLoad
                    : void 0,
                ),
                this.$(document).bind(
                  "spr:reviews:loaded",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onReviewsLoad
                    : void 0,
                ),
                this.$(document).bind(
                  "spr:form:loaded",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onFormLoad
                    : void 0,
                ),
                this.$(document).bind(
                  "spr:form:success",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onFormSuccess
                    : void 0,
                ),
                this.$(document).bind(
                  "spr:form:failure",
                  "undefined" != typeof SPRCallbacks && null !== SPRCallbacks
                    ? SPRCallbacks.onFormFailure
                    : void 0,
                )
              );
            }),
            (e.loadStylesheet = function () {
              var e, t;
              return (
                (t = document.createElement("link")),
                t.setAttribute("rel", "stylesheet"),
                t.setAttribute("type", "text/css"),
                t.setAttribute(
                  "href",
                  "https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css",
                ),
                t.setAttribute("media", "screen"),
                (e = document.getElementsByTagName("head")[0]),
                e.appendChild(t)
              );
            }),
            (e.initRatingHandler = function () {
              return e
                .$(document)
                .on("mouseover mouseout", "form a.spr-icon-star", function (t) {
                  var r, a, i;
                  return (
                    (r = t.currentTarget),
                    (i = e.$(r).attr("data-value")),
                    (a = e.$(r).parent()),
                    "mouseover" === t.type
                      ? (a
                          .find("a.spr-icon:lt(" + i + ")")
                          .addClass("spr-icon-star-hover"),
                        a
                          .find("a.spr-icon:gt(" + (i - 1) + ")")
                          .removeClass("spr-icon-star-hover"))
                      : a.find("a.spr-icon").removeClass("spr-icon-star-hover")
                  );
                });
            }),
            (e.initDomEls = function () {
              return (
                (this.badgeEls = this.$(
                  ".shopify-product-reviews-badge[data-id]",
                )),
                (this.reviewEls = this.$("#shopify-product-reviews[data-id]")),
                this.$.each(
                  this.reviewEls,
                  (function (e) {
                    return function (t, r) {
                      var a;
                      return (
                        (a = e.$(r).attr("data-id")),
                        (e.elSettings[a] = {}),
                        (e.elSettings[a].reviews_el =
                          "#" +
                          (e.$(r).attr("data-reviews-prefix")
                            ? e.$(r).attr("data-reviews-prefix")
                            : "reviews_")),
                        (e.elSettings[a].form_el =
                          "#" +
                          (e.$(r).attr("data-form-prefix")
                            ? e.$(r).attr("data-form-prefix")
                            : "form_"))
                      );
                    };
                  })(this),
                )
              );
            }),
            (e.loadProducts = function () {
              return this.$.each(
                this.reviewEls,
                (function (e) {
                  return function (t, r) {
                    var a, i;
                    if (
                      ((a = e.$(r).attr("data-id")),
                      "false" !== e.$(r).attr("data-autoload"))
                    )
                      return (
                        (i = e.$.extend(
                          { product_id: a, version: e.version },
                          e.extraAjaxParams,
                        )),
                        e.$.get(
                          e.api_url + "/reviews/product",
                          i,
                          e.productCallback,
                          "jsonp",
                        )
                      );
                  };
                })(this),
              );
            }),
            (e.loadBadges = function () {
              var e, t, r, a, i;
              if (
                ((r = this.$.map(
                  this.badgeEls,
                  (function (e) {
                    return function (t) {
                      return e.$(t).attr("data-id");
                    };
                  })(this),
                )),
                r.length > 0)
              ) {
                for (t = 7, i = []; (e = r.splice(0, t)).length > 0; )
                  ((a = this.$.extend(this.extraAjaxParams, {
                    product_ids: e,
                  })),
                    i.push(
                      this.$.get(
                        this.api_url + "/reviews/badges",
                        a,
                        this.badgesCallback,
                        "jsonp",
                      ),
                    ));
                return i;
              }
            }),
            (e.pageReviews = function (e) {
              var t, r, a;
              return (
                (a = this.$(e).data("product-id")),
                (r = this.$(e).data("page")),
                (t = this.$.extend(
                  { page: r, product_id: a },
                  this.extraAjaxParams,
                )),
                this.$.get(
                  this.api_url + "/reviews",
                  t,
                  this.paginateCallback,
                  "jsonp",
                ),
                !1
              );
            }),
            (e.submitForm = function (e) {
              var t;
              return (
                (t = this.$(e).serializeObject()),
                (t = this.$.extend(t, this.extraAjaxParams)),
                (t = this.$.param(t)),
                (t = t.replace(/%0D%0A/g, "%0A")),
                this.$.ajax({
                  url: this.api_url + "/reviews/create",
                  type: "GET",
                  dataType: "jsonp",
                  data: t,
                  success: this.formCallback,
                  beforeSend: (function (e) {
                    return function () {
                      return e
                        .$(".spr-button-primary")
                        .attr("disabled", "disabled");
                    };
                  })(this),
                  complete: (function (e) {
                    return function () {
                      return e.$(".spr-button-primary").removeAttr("disabled");
                    };
                  })(this),
                }),
                !1
              );
            }),
            (e.reportReview = function (e) {
              var t;
              return (
                confirm(
                  "Are you sure you want to report this review as inappropriate?",
                ) &&
                  ((t = this.$.extend({ id: e }, this.extraAjaxParams)),
                  this.$.get(
                    this.api_url + "/reviews/report",
                    t,
                    this.reportCallback,
                    "jsonp",
                  )),
                !1
              );
            }),
            (e.toggleReviews = function (e) {
              var t;
              return (
                (t = this.$("#shopify-product-reviews[data-id='" + e + "']")),
                t.find(".spr-reviews").toggle()
              );
            }),
            (e.toggleForm = function (e) {
              var t;
              return (
                (t = this.$("#shopify-product-reviews[data-id='" + e + "']")),
                t.find(".spr-form").toggle()
              );
            }),
            (e.setRating = function (e) {
              var t, r, a;
              return (
                (t = this.$(e).parents("form")),
                (a = this.$(e).attr("data-value")),
                (r = this.$(e).parent()),
                t.find("input[name='review[rating]']").val(a),
                this.setStarRating(a, r)
              );
            }),
            (e.setStarRating = function (e, t) {
              return (
                t
                  .find("a:lt(" + e + ")")
                  .removeClass("spr-icon-star-empty spr-icon-star-hover"),
                t
                  .find("a:gt(" + (e - 1) + ")")
                  .removeClass("spr-icon-star-hover")
                  .addClass("spr-icon-star-empty")
              );
            }),
            (e.badgesCallback = function (t) {
              var r;
              return (
                (r = t.badges),
                e.$.map(e.badgeEls, function (t) {
                  var a;
                  if (((a = e.$(t).attr("data-id")), r[a] !== undefined))
                    return (
                      e.$(t).replaceWith(r[a]),
                      e.triggerEvent("spr:badge:loaded", { id: a })
                    );
                })
              );
            }),
            (e.productCallback = function (t) {
              var r;
              return (
                (r = t.remote_id.toString()),
                e.renderProduct(r, t.product),
                e.renderForm(r, t.form),
                e.renderReviews(r, t.reviews)
              );
            }),
            (e.renderProduct = function (e, t) {
              return this.$.map(
                this.reviewEls,
                (function (r) {
                  return function (a) {
                    if (e === r.$(a).attr("data-id"))
                      return (
                        r.$(a).html(innerShiv(t, !1)),
                        r.triggerEvent("spr:product:loaded", { id: e })
                      );
                  };
                })(this),
              );
            }),
            (e.renderForm = function (e, t) {
              var r;
              return (
                (r = this.$(this.elSettings[e].form_el + e)),
                r.html(t),
                this.triggerEvent("spr:form:loaded", { id: e })
              );
            }),
            (e.renderReviews = function (t, r) {
              var a;
              return (
                (a = e.$(e.elSettings[t].reviews_el + t)),
                a.html(r),
                e.triggerEvent("spr:reviews:loaded", { id: t })
              );
            }),
            (e.formCallback = function (t) {
              var r, a, i, n;
              return (
                (n = t.status),
                (i = t.remote_id),
                (a = t.form),
                (r = e.$(e.elSettings[i].form_el + i)),
                r.html(a),
                "failure" === n && e.initStarRating(r),
                "success" === n &&
                  e
                    .$(
                      "#shopify-product-reviews[data-id='" +
                        i +
                        "'] .spr-summary-actions-newreview",
                    )
                    .hide(),
                e.triggerEvent("spr:form:" + n, { id: i })
              );
            }),
            (e.initStarRating = function (e) {
              var t, r, a;
              if ((a = e.find("input[name='review[rating]']")) && a.val())
                return (
                  (r = a.val()),
                  (t = e.find(".spr-starrating")),
                  this.setStarRating(r, t)
                );
            }),
            (e.paginateCallback = function (t) {
              var r, a;
              return (
                (a = t.remote_id.toString()),
                (r = t.reviews),
                e.renderReviews(a, r)
              );
            }),
            (e.reportCallback = function (t) {
              var r;
              return (
                (r = "#report_" + t.id),
                e
                  .$(r)
                  .replaceWith(
                    "<span class='spr-review-reportreview'>" +
                      e.$(r).attr("data-msg") +
                      "</span>",
                  )
              );
            }),
            (e.loadjQuery = function (t) {
              return e.loadScript(
                "//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",
                function () {
                  return ((e.$ = jQuery.noConflict(!0)), t());
                },
              );
            }),
            (e.loadScript = function (e, t) {
              var r;
              return (
                (r = document.createElement("script")),
                (r.type = "text/javascript"),
                r.readyState
                  ? (r.onreadystatechange = function () {
                      if (
                        "loaded" === r.readyState ||
                        "complete" === r.readyState
                      )
                        return ((r.onreadystatechange = null), t());
                    })
                  : (r.onload = function () {
                      return t();
                    }),
                (r.src = e),
                document.getElementsByTagName("head")[0].appendChild(r)
              );
            }),
            (e.loadjQueryExtentions = function (e) {
              return (e.fn.serializeObject = function () {
                var t, r;
                return (
                  (t = {}),
                  (r = this.serializeArray()),
                  e.each(r, function () {
                    return t[this.name]
                      ? (t[this.name].push || (t[this.name] = [t[this.name]]),
                        t[this.name].push(this.value || ""))
                      : (t[this.name] = this.value || "");
                  }),
                  t
                );
              });
            }),
            (e.triggerEvent = function (e, t) {
              return this.$(document).trigger(e, t);
            }),
            e
          );
        })()),
          (function () {
            (SPR.loadStylesheet(),
              SPR.loadjQuery(function () {
                return (
                  SPR.$.ajaxSetup({ cache: !1 }),
                  SPR.loadjQueryExtentions(SPR.$),
                  SPR.$(document).ready(function () {
                    return (
                      SPR.registerCallbacks(),
                      SPR.initRatingHandler(),
                      SPR.initDomEls(),
                      SPR.loadProducts(),
                      SPR.loadBadges()
                    );
                  })
                );
              }));
          })());
      }).call(this);
    })(
      "undefined" != typeof global
        ? global
        : "undefined" != typeof window && window,
    );
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  if (this.queryParams.display == "list") {
    jQ(".productgrid--outer").addClass("productgrid-listview");
  } else {
    jQ(".productgrid--outer").removeClass("productgrid-listview");
  }
  //jQ('#bc-sf-filter-products').css('display', 'flex');

  // Build Breadcrumb of Search page
  if (this.isSearchPage()) {
    var content = "";
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
      content = bcSfFilterConfig.label.search_breadcrumbs_count_other;
      if (data.total_product == 1) {
        content = bcSfFilterConfig.label.search_breadcrumbs_count_one;
      } else if (data.total_product == 0) {
        content = bcSfFilterConfig.label.search_breadcrumbs_count_zero;
      }
      content = content
        .replace(/{{ count }}/g, data.total_product)
        .replace(/{{ terms }}/g, searchTerm);
      content = content
        .replace(/&lt;strong&gt;/g, "<strong>")
        .replace(/&lt;\/strong&gt;/g, "</strong>");
    }
    jQ(".breadcrumbs-container span:last-child").html(content);
    jQ(".breadcrumbs-container span").css("display", "inline-block");
  }
};

/// Fix: Recently Viewed
// + empire.js
//
// + Find: RecentlyViewed và recentlyViewed = JSON.parse
//
// + Replace by recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
// if(typeof bcsffilter === 'undefined' || (typeof bcsffilter !== 'undefined' && bcsffilter.queryParams.event_type == 'init' && bcsffilter.hasFilterOptionParam === false)){

// Build Default layout
function buildDefaultLink(a, b) {
  var c = window.location.href.split("?")[0];
  return (c += "?" + a + "=" + b);
}
BCSfFilter.prototype.buildDefaultElements = function (a) {
  if (
    bcSfFilterConfig.general.hasOwnProperty("collection_count") &&
    jQ("#bc-sf-filter-bottom-pagination").length > 0
  ) {
    var b = bcSfFilterConfig.general.collection_count,
      c = parseInt(this.queryParams.page),
      d = Math.ceil(b / this.queryParams.limit);
    if (1 == d) return (jQ(this.selector.pagination).html(""), !1);
    if ("default" == this.getSettingValue("general.paginationType")) {
      var e = bcSfFilterTemplate.paginateHtml,
        f = "";
      ((f =
        c > 1
          ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")
            ? bcSfFilterTemplate.previousActiveHtml
            : bcSfFilterTemplate.previousHtml
          : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")
            ? bcSfFilterTemplate.previousDisabledHtml
            : ""),
        (f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1))),
        (e = e.replace(/{{previous}}/g, f)));
      var g = "";
      ((g =
        c < d
          ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")
            ? bcSfFilterTemplate.nextActiveHtml
            : bcSfFilterTemplate.nextHtml
          : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")
            ? bcSfFilterTemplate.nextDisabledHtml
            : ""),
        (g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1))),
        (e = e.replace(/{{next}}/g, g)));
      for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i);
      (c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c));
      for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k);
      (c + 3 < d && j.push("..."), c + 3 <= d && j.push(d));
      for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)
        ("..." == m[n]
          ? (l += bcSfFilterTemplate.pageItemRemainHtml)
          : (l +=
              m[n] == c
                ? bcSfFilterTemplate.pageItemSelectedHtml
                : bcSfFilterTemplate.pageItemHtml),
          (l = l.replace(/{{itemTitle}}/g, m[n])),
          (l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n]))));
      ((e = e.replace(/{{pageItems}}/g, l)),
        jQ(this.selector.pagination).html(e));
    }
  }
  if (
    bcSfFilterTemplate.hasOwnProperty("sortingHtml") &&
    jQ(this.selector.topSorting).length > 0
  ) {
    jQ(this.selector.topSorting).html("");
    var o = this.getSortingList();
    if (o) {
      var p = "";
      for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>";
      var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
      jQ(this.selector.topSorting).html(r);
      var s =
        void 0 !== this.queryParams.sort_by
          ? this.queryParams.sort_by
          : this.defaultSorting;
      (jQ(this.selector.topSorting + " select").val(s),
        jQ(this.selector.topSorting + " select").change(function (a) {
          window.location.href = buildDefaultLink("sort_by", jQ(this).val());
        }));
    }
  }
};

BCSfFilter.prototype.prepareProductData = function (data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]["images"] = data[k]["images_info"];
    if (data[k]["images"].length > 0) {
      data[k]["featured_image"] = data[k]["images"][0];
    } else {
      data[k]["featured_image"] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: "",
        height: "",
        aspect_ratio: 0,
      };
    }
    data[k]["url"] = "/products/" + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]["options_with_values"].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;
    if (
      typeof bcSfFilterConfig.general.currencies != "undefined" &&
      bcSfFilterConfig.general.currencies.length > 1
    ) {
      var currentCurrency = bcSfFilterConfig.general.current_currency
        .toLowerCase()
        .trim();
      function updateMultiCurrencyPrice(oldPrice, newPrice) {
        if (typeof newPrice != "undefined") {
          return newPrice;
        }
        return oldPrice;
      }
      data[k].price_min = updateMultiCurrencyPrice(
        data[k].price_min,
        data[k]["price_min_" + currentCurrency],
      );
      data[k].price_max = updateMultiCurrencyPrice(
        data[k].price_max,
        data[k]["price_max_" + currentCurrency],
      );
      data[k].compare_at_price_min = updateMultiCurrencyPrice(
        data[k].compare_at_price_min,
        data[k]["compare_at_price_min_" + currentCurrency],
      );
      data[k].compare_at_price_max = updateMultiCurrencyPrice(
        data[k].compare_at_price_max,
        data[k]["compare_at_price_max_" + currentCurrency],
      );
    }
    ((data[k]["price_min"] *= 100),
      (data[k]["price_max"] *= 100),
      (data[k]["compare_at_price_min"] *= 100),
      (data[k]["compare_at_price_max"] *= 100));
    data[k]["price"] = data[k]["price_min"];
    data[k]["compare_at_price"] = data[k]["compare_at_price_min"];
    data[k]["price_varies"] = data[k]["price_min"] != data[k]["price_max"];
    var firstVariant = data[k]["variants"][0];
    if (getParam("variant") !== null && getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      var countVariants = data[k]["variants"].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]["variants"][i].available) {
          firstVariant = data[k]["variants"][i];
          break;
        }
      }
    }
    data[k]["selected_or_first_available_variant"] = firstVariant;
    var countVariants = data[k]["variants"].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];
      var variantOptions = variant["merged_options"];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]["variants"][i]["options"] = variantOptionArr;
      }
      data[k]["variants"][i]["compare_at_price"] =
        parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
      data[k]["variants"][i]["price"] =
        parseFloat(data[k]["variants"][i]["price"]) * 100;
    }
    data[k]["description"] = data[k]["content"] = data[k]["body_html"];
  }
  return data;
};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem = function (e, r, t, i) {
  ((e = jQ.parseHTML(e)),
    (i = void 0 !== i ? i : this.getSelector("filterTree")));
  void 0 !== r && "before" == r ? jQ(i + t).prepend(e) : jQ(i + t).append(e);
};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== "undefined" ? ext : "png";
  var version = typeof version !== "undefined" ? version : "1";
  var prIndex = self.fileUrl.lastIndexOf("?");
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex);
  } else {
    var filePath = self.fileUrl;
  }
  filePath += fileName + "." + ext + "?v=" + version;
  return filePath;
}

BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
  function BCSend(eventType, errorCount) {
    var self = bcsffilter;
    var errorCount = typeof errorCount !== "undefined" ? errorCount : 0;
    self.showLoading();
    if (typeof self.buildPlaceholderProductList == "function") {
      self.buildPlaceholderProductList(eventType);
    }
    self.beforeGetFilterData(eventType);
    self.prepareRequestParams(eventType);
    self.queryParams["callback"] = "BCSfFilterCallback";
    self.queryParams["event_type"] = eventType;
    var url = self.isSearchPage()
      ? self.getApiUrl("search")
      : self.getApiUrl("filter");
    var script = document.createElement("script");
    script.type = "text/javascript";
    var timestamp = new Date().getTime();
    script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams);
    script.id = "bc-sf-filter-script";
    script.async = true;
    var resendAPITimer, resendAPIDuration;
    resendAPIDuration = 2e3;
    script.addEventListener("error", function (e) {
      if (typeof document.getElementById(script.id).remove == "function") {
        document.getElementById(script.id).remove();
      } else {
        document.getElementById(script.id).outerHTML = "";
      }
      if (errorCount < 3) {
        errorCount++;
        if (resendAPITimer) {
          clearTimeout(resendAPITimer);
        }
        resendAPITimer = setTimeout(
          self.getFilterData("resend", errorCount),
          resendAPIDuration,
        );
      } else {
        self.buildDefaultElements(eventType);
      }
    });
    document.getElementsByTagName("head")[0].appendChild(script);
    script.onload = function () {
      if (typeof document.getElementById(script.id).remove == "function") {
        document.getElementById(script.id).remove();
      } else {
        document.getElementById(script.id).outerHTML = "";
      }
    };
  }
  this.requestFilter(BCSend, eventType, errorCount);
};
BCSfFilter.prototype.requestFilter = function (
  sendFunc,
  eventType,
  errorCount,
) {
  sendFunc(eventType, errorCount);
};

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (
  html,
  iLabel,
  iValue,
  fOType,
  fOId,
  fOLabel,
  fODisplayType,
  fOSelectType,
  fOItemValue,
  fOData,
) {
  var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic")
    ? fOData.keepValuesStatic
    : false;
  if (
    fOType == "review_ratings" &&
    this.getSettingValue("general.ratingSelectionStyle") == "text"
  ) {
    var title = this.getReviewRatingsLabel(fOItemValue.from);
  } else {
    var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType);
  }
  if (keepValuesStatic === true) var productNumber = null;
  else
    var productNumber = fOItemValue.hasOwnProperty("doc_count")
      ? fOItemValue.doc_count
      : 0;
  html = html.replace(
    /{{itemLabel}}/g,
    this.buildFilterOptionLabel(iLabel, productNumber, fOData),
  );
  html = html.replace(
    /{{itemLink}}/g,
    this.buildFilterOptionLink(
      fOId,
      iValue,
      fOType,
      fODisplayType,
      fOSelectType,
      keepValuesStatic,
    ),
  );
  html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue));
  html = html.replace(/{{itemTitle}}/g, title);
  html = html.replace(
    /{{itemFunc}}/g,
    "onInteractWithFilterOptionValue(event, this, '" +
      fOType +
      "', '" +
      fODisplayType +
      "', '" +
      fOSelectType +
      "', '" +
      keepValuesStatic +
      "')",
  );
  html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType)
    ? html.replace(/{{itemSelected}}/g, "selected")
    : html.replace(/{{itemSelected}}/g, "");
  var htmlElement = jQ(html);
  htmlElement.children().attr({
    "data-id": fOId,
    "data-value": encodeURIParamValue(iValue),
    "data-parent-label": fOLabel,
    "data-title": title,
    "data-count": productNumber,
  });
  if (fOType != "collection") {
    htmlElement.children().attr("rel", "nofollow");
  }
  if (fOType == "collection")
    htmlElement.children().attr("data-collection-scope", fOItemValue.key);
  return jQ(htmlElement)[0].outerHTML;
};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
((BCSfFilter.prototype.initFilter = function () {
  return this.isBadUrl()
    ? void (window.location.href = window.location.pathname)
    : (this.updateApiParams(!1), void this.getFilterData("init"));
}),
  (BCSfFilter.prototype.isBadUrl = function () {
    try {
      var t = decodeURIComponent(window.location.search).split("&"),
        e = !1;
      if (t.length > 0)
        for (var i = 0; i < t.length; i++) {
          var n = t[i],
            a = (n.match(/</g) || []).length,
            r = (n.match(/>/g) || []).length,
            o = (n.match(/alert\(/g) || []).length,
            h = (n.match(/execCommand/g) || []).length;
          if ((a > 0 && r > 0) || a > 1 || r > 1 || o || h) {
            e = !0;
            break;
          }
        }
      return e;
    } catch (l) {
      return !0;
    }
  }));
/* End patch boost-010 run 2 */
